import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="page"
export default class extends Controller {
  connect() {
    window.addEventListener('scroll', this.scroll.bind(this))
  }

  scroll() {
    let top = window.scrollY;
    let y = top;

    if (y > 100) y = 100;

    document.querySelector('.page__head').style.opacity = (100 - y) / 100;
    document.querySelector('.page__head').style.filter = `blur(${y / 15}px)`
    document.querySelector('.page__head').classList.toggle('page__head--sticky', y == 100);

    //document.querySelector('.page__head .header').style.transform = `translate3d(0, -${y / 1.8}px, 0)`
  }
}
